import { type IconButtonProps, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { type OmitFramerProps } from '@/lib/types';
import { FormattedMessage } from 'react-intl';
import { useContext } from 'react';
import PortfolioItemCloseBlockingContext from '../../../PortfolioItemCloseBlockingContext';
import StyledCloseButton from './StyledCloseButton';
import CloseBlockedIndicator from './CloseBlockedIndicator';

type CloseButtonProps = Omit<
  OmitFramerProps<IconButtonProps>,
  'color' | 'size' | 'children'
> & {
  taskBoardOpen: boolean;
};

const CloseButton = ({ taskBoardOpen, ...props }: CloseButtonProps) => {
  const { isPortfolioItemCloseBlocked } = useContext(
    PortfolioItemCloseBlockingContext,
  );

  return (
    <Tooltip
      title={<FormattedMessage id="portfolio.challenge.close_button.tooltip" />}
    >
      <StyledCloseButton
        color="primary"
        size="large"
        initial={{
          x: 10,
          opacity: 0,
        }}
        animate={{
          x: 0,
          opacity: 1,
          transition: {
            duration: 0.1,
            delay: 0.3,
          },
        }}
        taskBoardOpen={taskBoardOpen}
        {...props}
      >
        <CloseIcon />
        <CloseBlockedIndicator
          visible={isPortfolioItemCloseBlocked && !taskBoardOpen}
        />
      </StyledCloseButton>
    </Tooltip>
  );
};

export default CloseButton;
